module.exports = __webpack_public_path__ + "img/std-wien-v2.a7d0f3f1.png";